import { translateEnglishWords, translatePhrase } from '@/composables/translation';

const lichessCommandWordList = "command explain abort resign draw take back done offer offered accept repeat listen mute describe claim";
const computerCommandWordList = "command explain start game end new option options take back review replay reveal revert done repeat listen mute describe";
const friendCommandWordList = "command explain start game end new option options take back replay reveal revert done repeat listen mute describe continue export flip";
const describeWordList = "black white rank file square locate left right up down";

const playWordList = "play ignore at move takes capture captures castle side short long";

const pieceNames = [ "rook","bishop", "knight","king", "queen", "pawn"];
const pieceValues = [ "R","B", "N","K", "Q", "P"];

const fileNames = ["alfa", "bravo", "charlie", "delta", "echo", "fox", "foxtrot", "golf", "hotel",
                        "anna", "bella", "cesar", "david", "eva", "felix",  "gustav", "hector",
                        "a", "b", "c", "d", "e", "f", "g", "h" ];
const fileValues = ["a", "b", "c", "d", "e", "f", "f", "g", "h",
                        "a", "b", "c", "d", "e", "f",  "g","h",
                        "a", "b", "c", "d", "e", "f", "g", "h"];

const rankNames = ["one", "two", "three", "four", "five", "six", "seven", "eight"];
const rankValues = ["1", "2", "3", "4", "5", "6", "7", "8"];

var anchorSquare = { rankNumber : 3, fileNumber : 3}

// Only English gets the file letters
export function buildWordList(whichProgram,languageInUse) {
    const pieceWordString = pieceNames.join( " ")

    //const fileNamesCopy = (languageInUse != "en") ? fileNames.slice(0,17) : fileNames
    const fileNamesCopy =  fileNames
    //console.log("array size in buildwordlist", fileNames.length, fileNamesCopy.length)
    const fileWordString = fileNamesCopy.join(" ")
    const rankWordString = rankNames.join(" ")

    var commandWordList = []
    switch (whichProgram) {
        case "computer" :
            commandWordList = computerCommandWordList
            break
        case "lichess" :
            commandWordList = lichessCommandWordList
            break
        case "friend" :
            commandWordList = friendCommandWordList
            break
    }

    const bigWordList = commandWordList + " " + playWordList + " " + pieceWordString + " " + fileWordString + " " + rankWordString + " " + describeWordList
    return bigWordList
}

export function parseLichessCommands(words,currentWordIndex) {
    
    var currentWord = (words.length  > currentWordIndex) ? words[currentWordIndex] : "xyz"
    var nextWord = (words.length  > currentWordIndex+1) ? words[currentWordIndex+1] : "xyz"
    var nextNextWord = (words.length  > currentWordIndex+2) ? words[currentWordIndex+2] : "xyz"

    for (var i = currentWordIndex; i < words.length; i++) {
        if (currentWord == "ignore") {
            return ["ignore",""];
        }
        if (currentWord == "claim") {
            return ["command","claim"];
        }
        if (currentWord == "resign") {
            return ["command","resign"];
        }
        if (currentWord == "explain") {
            return ["command","explain"];
        }
        if (currentWord == "done") {
            return ["command","done",""];
        }
        if (currentWord == "abort") {
            return ["command","abort"];
        }
        if (currentWord == "mute") {
            return ["command","mute"];
        }
        if (currentWord == "listen") {
            return ["command","listen"];
        }
        if (currentWord == "offer" && nextWord == "draw") {
            return ["command","draw"];
        }
        if (currentWord == "accept" && nextWord == "draw") {
            return ["command","draw"];
        }
        if (currentWord == "repeat") {
            return ["command","repeat",""];
        }
            
        currentWord = nextWord;
        nextWord = nextNextWord;
        nextNextWord = (i < words.length  - 3) ? words[i + 3] : "xyz";
    }
    return ["ignore",""];
}

export function parseComputerCommands(words,currentWordIndex) {
    
    var currentWord = (words.length  > currentWordIndex) ? words[currentWordIndex] : "xyz"
    var nextWord = (words.length  > currentWordIndex+1) ? words[currentWordIndex+1] : "xyz"
    var nextNextWord = (words.length  > currentWordIndex+2) ? words[currentWordIndex+2] : "xyz"

    for (var i = currentWordIndex; i < words.length; i++) {
        if (currentWord == "ignore") {
            return ["ignore",""];
        }
        if (currentWord == "mute") {
            return ["command","mute"];
        }
        if (currentWord == "listen") {
            return ["command","listen"];
        }
        if (currentWord == "explain") {
            return ["command","explain"]
        }
        if (currentWord == "start" && nextWord == "game") {
            return ["command","start game"]
        }
        if (currentWord == "continue" && nextWord == "game") {
            return ["command","continue game"]
        }
          if (currentWord == "export" ) {
            return ["command","export"]
        }
        if (currentWord == "end" && nextWord == "game") {
            return ["command","end game"]
        }
        if (currentWord == "new" && nextWord == "game") {
            return ["command","new game"]
        }
        if (currentWord == "take" && nextWord == "back") {
            return ["command","takeback"]
        }
        if (currentWord == "option" || currentWord == "options") {
            return ["command","options"]
        }
        if (currentWord == "review") {
            return ["command","review"]
        }
        if (currentWord == "flip") {
            return ["command","flip"]
        }
        if (currentWord == "replay") {
            return ["command","replay"]
        }
        if (currentWord == "reveal" || currentWord == "revert") {
            return ["command","reveal"]
        }

        if (currentWord == "done") {
            return ["command","done"]
        }
        if (currentWord == "repeat") {
            return ["command","repeat"]
        }

        currentWord = nextWord;
        nextWord = nextNextWord;
        nextNextWord = (i < words.length  - 3) ? words[i + 3] : "xyz";
    }
    return ["ignore",""];
}

function columnToNumber(letter) {
    const fileLetters = [ "a", "b", "c", "d", "e", "f", "g", "h"]

    for (var i =0; i < fileLetters.length; i++)
      if (letter == fileLetters[i])
        return (i)
    return (0)
}

  export function wordToSayForColumn(columnIndex , say )  {
        //console.log("word to say for column",say)
        switch (say) {
        case "words" :
            // use foxtrot for "f"
            let shifted = (columnIndex >= 5) ? columnIndex + 1 : columnIndex
            return (fileNames[shifted])
        case "names" :
            return (fileNames[columnIndex + 9])
        default :
            return (fileNames[columnIndex + 17].toUpperCase())
        }
    }

export function wordToSayForPieceLetter(piece) {
    let pieceUpper = piece.toUpperCase()
    for (var valueIndex =0; valueIndex < pieceValues.length; valueIndex++)  {
        let p = pieceValues[valueIndex]
        if (p == pieceUpper) {
            return (pieceNames[valueIndex])
        }
    }
        return ("")
}

export function processArrowKey(direction,sayFileWords,completeFen) {
    var rankNumber = anchorSquare.rankNumber
    var fileNumber = anchorSquare.fileNumber
    switch (direction) {
        case "left" :
            fileNumber--
            if (fileNumber == -1)
                fileNumber = 7
            break
        case "right" :
            fileNumber++
            if (fileNumber == 8)
                fileNumber = 0
            break
        case "up" :
            rankNumber++
            if (rankNumber == 8)
                rankNumber = 0
            break
        case "down" :
            rankNumber--
            if (rankNumber == -1)
                rankNumber = 7
            break
    }

    const fenParts = completeFen.split(" ")
    const fen = fenParts[0]
    const squareArray = new Array(64).fill(' ');
    var squareIndex = 0
    for (var i=0; i < fen.length; i++) {
        const oneChar = fen[i]
        if (oneChar == "/")
            continue
        if (oneChar >= "1" && oneChar <= "8")
            squareIndex += parseInt(oneChar)
        else {
            squareArray[squareIndex++] = oneChar
        }
    }

    squareIndex = (7-rankNumber) * 8 + fileNumber
    anchorSquare = { rankNumber : rankNumber, fileNumber : fileNumber}
    let fileWord = translateEnglishWords(wordToSayForColumn(fileNumber, sayFileWords))
    const rank = rankNumber + 1
    var bigString = fileWord + " " + rank

    const pieceAtSquare = squareArray[squareIndex]

    if (pieceAtSquare != " ") {
        let pieceNameToSay = translateEnglishWords(wordToSayForPieceLetter(pieceAtSquare))
        bigString += "\t"
        if (pieceAtSquare >= "a" && pieceAtSquare <= "z") {
            bigString += translateEnglishWords("black") + " "
        }
        else
        if (pieceAtSquare >= "A" && pieceAtSquare <= "Z") {
            bigString += translateEnglishWords("white") + " "
        }
        bigString += pieceNameToSay
    }
    return (bigString)
}

  export function processDescribe(location, rank,file,color,
                         piece, pieceName, sayFileWords, completeFen) {
        var bigString = ""

        var firstSquareIndex = -1
        var lastSquareIndex = -2
        var stepSquare = 1
        var currentColor = ""
        var pieceWithColor = ""
        var currentRank = 0
        var currentFile = 0
        
        var foundThePiece = false
        
        // if arrow directions then call processArrowKey
        if (location == "right" || location == "left" || location == "up" || location == "down") {
            bigString = processArrowKey(location,sayFileWords,completeFen)
            return (bigString)
        }
        
        // turn fen into 64 element array of blanks and pieces
        const fenParts = completeFen.split(" ")
        const fen = fenParts[0]
        const squareArray = new Array(64).fill(' ');
        var squareIndex = 0
        for (var i=0; i < fen.length; i++) {
            const oneChar = fen[i]
            if (oneChar == "/")
                continue
            if (oneChar >= "1" && oneChar <= "8")
                squareIndex += parseInt(oneChar)
            else {
                squareArray[squareIndex++] = oneChar
            }
        }

        //console.log("DEscribe FEN",fen)
        //console.log("squareArray ",squareArray)

        var useLocation = location
        if (location == "") {
            if (color != "" && piece != "") {
                useLocation = "locate"
            }
            else
            if (rank != "" && file == "") {
                useLocation = "rank"
            }
            else
            if (file != "" && rank == "") {
                useLocation = "file"
            }
            else
            if (file != "" && rank != "") {
                useLocation = "square"
            }
        }
                
        switch (useLocation) {
        case "locate" :
            if (color == "") {
                bigString = translatePhrase("locate needs color")
            }
            else
            if (piece == "") {
                bigString = translatePhrase("locate needs piece name")
            }
            else {
                currentRank = 1
                currentFile = 0
                firstSquareIndex = 56
                lastSquareIndex = 64
                stepSquare = 1
                pieceWithColor = (color == "black") ? piece.toLowerCase() : piece
                bigString = translateEnglishWords(color) + " " + translateEnglishWords(pieceName)
            }
            break
        case "square" :
            if (rank == "") {
                bigString = translatePhrase("rank not understood")
            }
            else
            if (file == "") {
                bigString = translatePhrase("file not understood")
            }
            else {
                let rankNumber = parseInt(rank) - 1
                let fileNumber = columnToNumber(file)
                let fileWord = translateEnglishWords(wordToSayForColumn(fileNumber, sayFileWords))

                firstSquareIndex = (7-rankNumber) * 8 + fileNumber
                lastSquareIndex = firstSquareIndex + 1
                stepSquare = 1
                bigString = translateEnglishWords("square ") + fileWord + " " + rank + " " + 
                                translateEnglishWords("has")
                anchorSquare = { rankNumber : rankNumber, fileNumber : fileNumber }
            }
            break;
        case "rank" :
            if (rank == "") {
                bigString = translatePhrase("rank not understood")
                // no rank given
            }
            else {
                let rankNumber = parseInt(rank) - 1
                firstSquareIndex = (7-rankNumber) * 8
                let possibleLastSquareIndex = firstSquareIndex + 8
                stepSquare = 1
                
                // trim based on trailing blank squares
                var i = firstSquareIndex
                lastSquareIndex = firstSquareIndex
                while (i >= 0 && i != possibleLastSquareIndex) {
                    let pieceAtSquare = squareArray[i]
                    if (pieceAtSquare != " ") {
                        lastSquareIndex = i + 1
                    }
                    i += stepSquare
                }
                if (lastSquareIndex == firstSquareIndex) {
                    bigString = translateEnglishWords("rank") + " " + rank + " " + translatePhrase("is empty")
                }
                else {
                    bigString = translateEnglishWords("rank") + " " + rank + " " +
                                        translateEnglishWords("has")
                }
            }
            break;
        case "file" :
            if (file == "") {
                // no file given
                bigString = translatePhrase("file not understood")
            }
            else {
                let fileNumber = columnToNumber(file)
                firstSquareIndex = (56 + fileNumber)
                let possibleLastSquareIndex = fileNumber - 8
                
                // trim based on trailing blank squares
                var i = firstSquareIndex
                lastSquareIndex = firstSquareIndex
                stepSquare = -8
                while (i >= 0 && i != possibleLastSquareIndex) {
                    let pieceAtSquare = squareArray[i]
                    if (pieceAtSquare != " ") {
                        lastSquareIndex = i - 8
                    }
                    i += stepSquare
                }
                let fileWord = wordToSayForColumn(fileNumber, sayFileWords)

                if (lastSquareIndex == firstSquareIndex) {
                    bigString = translateEnglishWords("file") + " " + fileWord + " " + translatePhrase("is empty")
                }
                else {
                    bigString = translateEnglishWords("file") + " " + fileWord + " " +
                                                            translateEnglishWords("has")
                }

            }
            break
        default :
            //console.log("unknown location \(location)")
        }
     
       
        //print("Describe \(String(firstSquareIndex)) \(String(lastSquareIndex)) \(String(stepSquare))")
        
        var i = firstSquareIndex
        while (i >= 0 && i != lastSquareIndex) {
            
            let pieceAtSquare = squareArray[i]
            //print("Piece \(String(i)) \(pieceAtSquare)")
            
            i += stepSquare
            
            if (useLocation == "locate") {
                if (pieceAtSquare == pieceWithColor) {
                    if (!foundThePiece) {
                        bigString += " at "
                        foundThePiece = true
                    }
                    let fileWord = wordToSayForColumn(currentFile,sayFileWords)
                    bigString += "\t" + fileWord + " " + currentRank

                }
                // for locating pieces, do ranks 1 to 8 and files a to h
                if (firstSquareIndex > 0 && i == lastSquareIndex) {
                    currentFile = 0
                    currentRank += 1
                    firstSquareIndex -= 8
                    lastSquareIndex -= 8
                    i = firstSquareIndex
                }
                else {
                    currentFile += 1
                }
            }
            else
            if (pieceAtSquare == " ") {
                bigString += "\t" + translateEnglishWords("blank")
            }
            else {
                let pieceNameToSay = translateEnglishWords(wordToSayForPieceLetter(pieceAtSquare))
                bigString += "\t"
                if (pieceAtSquare >= "a" && pieceAtSquare <= "z" && currentColor != "black") {
                    bigString += translateEnglishWords("black") + " "
                    currentColor = "black"
                }
                else
                if (pieceAtSquare >= "A" && pieceAtSquare <= "Z" && currentColor != "white") {
                    bigString += translateEnglishWords("white") + " "
                    currentColor = "white"
                }
                bigString += pieceNameToSay
            }
        }
        
        if (useLocation == "locate" && foundThePiece == false) {
            bigString += " " + translatePhrase("not on board")
        }
        
        //console.log("DESCRIBE STRING",bigString)
        return (bigString)
    }
    

 export function parseDescribeCommands(words,currentWordIndex) {
    var foundMatch = false
    var color = ""
    var rank = ""
    var file = ""
    var piece = ""
    var pieceName = ""
    var location = ""
    
    var currentWord = (words.length > currentWordIndex) ? words[currentWordIndex] : "xyz"
    var nextWord = (words.length > currentWordIndex+1) ? words[currentWordIndex+1] : "xyz"
    var nextNextWord = (words.length > currentWordIndex+2) ? words[currentWordIndex+2] : "xyz"

    for (var i = currentWordIndex; i < words.length; i++) {
        foundMatch = false
        
        if (currentWord == "ignore") {
            return ["ignore",""];
        }
        
        if (currentWord == "locate" || currentWord == "square" 
            || currentWord == "rank" || currentWord == "file"
            || currentWord == "left" || currentWord == "right" || currentWord == "up" || currentWord == "down") {
            location = currentWord
        }
        else
        if (currentWord == "black" || currentWord == "white") {
            color = currentWord
        }
        else {
            // check for rank, file, piece
            for (var nameIndex = 0; nameIndex < rankNames.length; nameIndex++) {
                if (rankNames[nameIndex] == currentWord) {
                    rank = rankValues[nameIndex];
                    foundMatch = true
                    break
                }
            }
            
            if (!foundMatch) {
                for (var nameIndex = 0; nameIndex < fileNames.length; nameIndex++) {
                    if (fileNames[nameIndex] == currentWord) {
                        file = fileValues[nameIndex];
                        foundMatch = true
                        break
                    }
                }
            }
            
            if (!foundMatch) {
                for (var nameIndex = 0; nameIndex < pieceNames.length; nameIndex++) {
                    let p = pieceNames[nameIndex]
                    if (p == currentWord) {
                        piece = pieceValues[nameIndex]
                        pieceName = pieceNames[nameIndex]
                        foundMatch = true
                        break;
                    }
                }
            }
        }
            
        currentWord = nextWord;
        nextWord = nextNextWord;
        nextNextWord = (i < words.length - 3) ? words[i + 3] : "xyz";
    }
    
    return ["describe",location,rank,file,color,piece,pieceName]
}

function checkSan(saidMove,san) {

    //console.log("check san",saidMove,san)
    var saidCharIndex = 0
    var foundMatch = true

    for (var j=0; j < san.length; j++) {
        const san_char =  san.charAt(j)

        // ignore these.  note: could be at end of "saidMove" but still hit one of these in the san
        if (san_char == "x" || san_char == "+" || san_char == "#") {
            continue;
        }

        // if = then ignore the promotion since we always promote to queen, be done
        if (san_char == "=") {
            saidCharIndex = saidMove.length 
            break;
        }
        // if we ran out of characters to compare, can't be a match
        if (saidCharIndex >= saidMove.length) {
            foundMatch = false;
            break;
        }
        if (san_char != saidMove[saidCharIndex]) {
            foundMatch = false;
            break;
        }
        // so far, so good. see if the next character is a match
        saidCharIndex += 1;
    }

    // did we account for all the characters said?
    if (saidCharIndex < saidMove.length) {
        foundMatch = false;
    }
    return (foundMatch)
}

export function parsePlay(words,currentWordIndex,availableMoves,mustSayPieceName) {
    
    var foundMatch = false;
    var saidMove = "";
    var repeatBackMove = "";

    // these are if the user said the rank "2" intending "bishop to d 5"
    var alternateSaidMove = "";
    var alternateRepeatBackMove = "";

    var pieceWord = "";

    var hasPiece = false
    var pieceIsPawn = false
    var hasFile1 = false
    var hasRank1 = false
    var hasFile2 = false
    var hasRank2 = false;
    var saidCastle = false;
    var saidShortLong = false;
    var whichSideCastle = 0;              // 1=short, 2=long

    var piece = "";
    var file1 = "";
    var rank1 = "";
    var rank1Word = ""
    var file2 = "";
    var rank2 = "";
    var rank2Word = ""
    
    var currentWord = (words.length  > currentWordIndex) ? words[currentWordIndex] : "xyz"
    var nextWord = (words.length  > currentWordIndex+1) ? words[currentWordIndex+1] : "xyz"
    var nextNextWord = (words.length  > currentWordIndex+2) ? words[currentWordIndex+2] : "xyz"

    for (var i = currentWordIndex; i < words.length; i++) {
        if (words[i] == "ignore") {
            return (["ignore",""]);
        }

        foundMatch = false;
    
        // only look for piece if we haven't seen a file or rank. I.e, at the beginning
        if (hasFile1 == false && hasFile2 == false && hasRank1 == false && hasRank2 == false) {
            for (var nameIndex = 0; nameIndex < pieceNames.length; nameIndex++) {
                const p = pieceNames[nameIndex]
                if (p == currentWord) {
                    pieceWord = p
                    hasPiece = true;
                    piece = pieceValues[nameIndex]
                    if (piece == "P") {
                        pieceIsPawn = true;
                    }
                    foundMatch = true;
                    break;
                }
            }
        }
        
        if (!foundMatch) {
            for (var nameIndex = 0; nameIndex < fileNames.length; nameIndex++) {
                if (fileNames[nameIndex] == currentWord) {
                    if (hasFile1) {
                        hasFile2 = true;
                        file2 = fileValues[nameIndex];
                    }
                    else {
                        hasFile1 = true;
                        file1 = fileValues[nameIndex];
                    }
                    foundMatch = true;
                    break;
                }
            }
        }

        if (!foundMatch) {
            for (var nameIndex = 0; nameIndex < rankNames.length; nameIndex++) {
                if (rankNames[nameIndex] == currentWord) {
                    if (hasRank1) {
                        hasRank2 = true;
                        rank2 = rankValues[nameIndex];
                        rank2Word = rankNames[nameIndex]
                    }
                    else {
                        hasRank1 = true;
                        rank1 = rankValues[nameIndex];
                        rank1Word = rankNames[nameIndex]
                    }
                    foundMatch = true;
                    break;
                }
            }
        }

        // add in castle
        if (!foundMatch) {
            if (currentWord == "castle") {
                saidCastle = true;
            }
            else
            if (currentWord == "short") {
                saidShortLong = true;
                whichSideCastle = 1;
            }
            else
            if (currentWord == "long") {
                saidShortLong = true;
                whichSideCastle = 2;
            }
        }
        currentWord = nextWord;
        nextWord = nextNextWord;
        nextNextWord = (i < words.length  - 3) ? words[i + 3] : "xyz";
    }
     
    // handle castle first
    if (saidCastle) {
        if (saidShortLong) {
            saidMove = (whichSideCastle == 1) ? "O-O" : "O-O-O"
            repeatBackMove = (whichSideCastle == 1) ? translateEnglishWords("castle") : translateEnglishWords("castle long")
        }
        else
        if (hasPiece && piece == "K") {
            saidMove = "O-O"
            repeatBackMove = translateEnglishWords("castle")
        }
        else
        if (hasPiece && piece == "Q") {
            saidMove = "O-O-O"
            repeatBackMove = translateEnglishWords("castle long")
        }
        else {
            // which side, not specified, if one exists, use that if both - ambiguous
            var kingSideCastleValid = false;
            var queenSideCastleValid = false;
            for (var i=0; i < availableMoves.value.length; i++) {
                const oneMove = availableMoves.value[i]
                const san = oneMove.san
                if (san == "O-O" || san == "O-O+" || san == "O-O#") {
                     kingSideCastleValid = true;
                }
                else
                if (san == "O-O-O" || san == "O-O-O+" || san == "O-O-O#") {
                    queenSideCastleValid = true;
                }
            }

            // both sides valid so "castle" by itself is ambiguous
            if (kingSideCastleValid && queenSideCastleValid) {
                return ["ambiguous","Castle is ambiguous",translatePhrase("Castle is ambiguous")]
            }
            if (kingSideCastleValid == false && queenSideCastleValid == false) {
                 return ["ignore",""]
            }
            saidMove = (kingSideCastleValid) ? "O-O" : "O-O-O";
            repeatBackMove = (whichSideCastle == 1) ? translateEnglishWords("castle") : translateEnglishWords("castle long")
        }
    }
    else {
        // if no file & rank then ignore
        if (hasFile1 == false || hasRank1 == false) {
            return ["ignore",""]
        }

        // if 'piece name' required, enforce that
        if (mustSayPieceName && hasPiece == false) {
            return ["ignore",""]
        }

        // if they gave two sets of file/rank then treat as from -> to
        if (hasFile2 && hasRank2) {
            var colNumber = columnToNumber(file1)
            const fromSquareNumber = (8 - rank1) * 8 + colNumber
            colNumber = columnToNumber(file2)
            const toSquareNumber = (8 - rank2) * 8 + colNumber
            //console.log("******** fully qualified ",file1,rank1,file2,rank2,fromSquareNumber,toSquareNumber)
            for (var i=0;  i < availableMoves.value.length; i++) {
                const oneMove = availableMoves.value[i]
                if (oneMove.from == fromSquareNumber && oneMove.to == toSquareNumber) {
                    return ["play",i];
                }
            }
        }
        // if they said a piece and it isn't a pawn
        if (hasPiece && pieceIsPawn == false) {
            // worry about ambiguous stuff later
            if (hasFile2 && hasRank2) {
                saidMove = piece + file1 + rank1 + file2 + rank2;
                repeatBackMove = translateEnglishWords(pieceWord) + " " + translateEnglishWords("on file") + " " + 
                            translateEnglishWords(file1.toUpperCase()) + " " + 
                            translateEnglishWords("and rank") + " " + translateEnglishWords(rank1Word) + 
                            " " + translateEnglishWords("moving to") + " " + 
                            translateEnglishWords(file2.toUpperCase()) + " " + translateEnglishWords(rank2Word)
            }
            else
            if (hasFile2 && !hasRank2) {
                saidMove = piece + file1 + file2 + rank1;
                repeatBackMove = translateEnglishWords(pieceWord) + " " + translateEnglishWords("on file") + " " + 
                            translateEnglishWords(file1.toUpperCase()) +  " " + 
                            translateEnglishWords("moving to") + " " + 
                            translateEnglishWords(file2.toUpperCase()) + " " + translateEnglishWords(rank1Word)

            }
            else
            if (!hasFile2 && hasRank2) {
                saidMove = piece + rank1 + file1 + rank2;
                repeatBackMove = translateEnglishWords(pieceWord) + " " + translateEnglishWords("on rank") + " " + 
                            translateEnglishWords(rank1Word) + " " + 
                            translateEnglishWords("moving to") + " " + 
                            translateEnglishWords(file1.toUpperCase()) + " " + translateEnglishWords(rank2Word)

                // maybe the rank was "bishop to d 5" (Bd5) and not "bishop two d 5" (B2d5)
                if (rank1 == 2) {
                    alternateSaidMove = piece + file1 + rank2;
                    alternateRepeatBackMove = translateEnglishWords(pieceWord) + " " + translateEnglishWords(file1.toUpperCase()) + " " + 
                    translateEnglishWords(rank2Word)
                }
                //console.log("had rank1 ",saidMove,alternateSaidMove)
            }
            else {
                saidMove = piece + file1 + rank1;
                repeatBackMove = translateEnglishWords(pieceWord) + " " + translateEnglishWords("to") + " " + translateEnglishWords(file1.toUpperCase()) + " " + translateEnglishWords(rank1Word)
            }
        }
        else {
            // didn't say a piece or they said "pawn"

            // if there are two "files" then it is a capture of
            if (hasFile2) {
                saidMove = file1 + file2 + rank1;
                repeatBackMove = translateEnglishWords("pawn on file") + " " + 
                        translateEnglishWords(file1.toUpperCase()) +  " " + 
                        translateEnglishWords("moving to") + " " + translateEnglishWords(file2.toUpperCase()) + " " + 
                        translateEnglishWords(rank2Word)

            }
            else {
                saidMove = file1 + rank1;
                repeatBackMove = translateEnglishWords(file1.toUpperCase()) + " " + translateEnglishWords(rank1Word)
            }
        }
    }

    //console.log("avialable moves ",availableMoves.value)
    // compare the said string against possible moves
    for (var i=0;  i < availableMoves.value.length; i++) {
        const oneMove = availableMoves.value[i]
        const san = oneMove.san
        
        foundMatch = checkSan(saidMove,san)
        if (foundMatch == false) {
            // is there an alternate
            if (alternateSaidMove != "") {
                foundMatch = checkSan(alternateSaidMove,san)
                if (foundMatch == false)
                    continue
            }
            else
                continue;
        }
        return ["play",i];
    }

    return ["ambiguous",saidMove + " " + translatePhrase("not on move list"),translateEnglishWords("No") + "\t" + repeatBackMove]
}

export function parseGameWordsSaid(str,gameStarted,gameIsLichess,availableMoves,playKeywordRequired) {

    const words = str.split(" ")
    if (words.length  == 0) {
        return ["ignore",""];
    }
    var currentWord = (words.length  > 0) ? words[0] : "xyz"
    var nextWord = (words.length  > 1) ? words[1] : "xyz"
    var nextNextWord = (words.length  > 2) ? words[2] : "xyz"
 
    // find "play", "command" or "describe"
    
    for (var i=0;  i < words.length; i++)  {
        if (words[i] == "ignore") {
            return ["ignore",""];
        }

        if (currentWord == "play") {

            // if game hasn't started or no moves available, then ignore "play blah blah"
            if (gameStarted == false || availableMoves.value.length == 0) {
                return ["ignore",""];
            }

            const returnArray = parsePlay(words,i+1,availableMoves,false)
            return returnArray
        }
        if (currentWord == "command") {
            if (gameIsLichess) {
                const returnArray = parseLichessCommands(words, i+1)
                return returnArray
            }
            else {
                const returnArray = parseComputerCommands(words, i+1)
                return returnArray
            }
        }
        if (currentWord == "describe") {
            //console.log("before parseDescribe",words)
            const returnArray = parseDescribeCommands(words, i+1)
            return returnArray
        }

        // if 'play' not required, see if it is a valid move
        if ((playKeywordRequired == "no" || playKeywordRequired == "piece")
                        && gameStarted && availableMoves.value.length != 0) {
            let returnArray = parsePlay(words, i,availableMoves,playKeywordRequired == "piece")
            if (returnArray[0] == "play" || returnArray[0] == "ambiguous") {
                return returnArray
            }
        }
        currentWord = nextWord;
        nextWord = nextNextWord;
        nextNextWord = (i < words.length  - 3) ? words[i + 3] : "xyz";
    }
    return ["ignore",""]
}